module.exports = __webpack_public_path__ + "static/media/question-mark-svgrepo-com.e2cbd4ff.svg";